import React from 'react';
import PropTypes from 'prop-types';
import RecommendedDrinks from '../components/RecommendedDrinks';
import StartRecipeButton from '../components/StartRecipeButton';
import ListDetailsFoods from '../components/ListDetailsFoods';
import BackButton from '../components/BackButton';

function FoodsDetails(props) {
  const { match: { params: { id } } } = props;
  const { location: { pathname } } = props;
  return (
    <div className="d-detailsPage">
      <BackButton />
      <ListDetailsFoods id={ id } pathname={ pathname } />
      <RecommendedDrinks />
      <StartRecipeButton type="foods" id={ id } />
    </div>
  );
}

FoodsDetails.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.string }),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string }).isRequired,
};

export default FoodsDetails;
